import { useDispatch } from "react-redux"
import { Actions } from "../actions"
import { Box, Button, Typography, CircularProgress, Alert, Paper, Chip } from '@mui/material'
import styles from './style'
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function UploadMasavConfirmation({
    onMount, loading, currentExport, isSubmitting, uploadSuccess, error, onSubmit
}) {
    const dispatch = useDispatch()
    const { id } = useParams()
    const navigate = useNavigate()
    const [selectedFile, setSelectedFile] = useState(null)
    const [previewUrl, setPreviewUrl] = useState(null)

    useEffect(() => {
        onMount({ id: parseInt(id) })
    }, [dispatch, id])

    useEffect(() => {
        if (uploadSuccess) {
            setTimeout(() => {
                navigate(`/masav-exports`)
            }, 2000)
        }
    }, [uploadSuccess, navigate])

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        if (file) {
            setSelectedFile(file)
            // Create preview URL for PDFs or images
            const url = URL.createObjectURL(file)
            setPreviewUrl(url)
        }
    }

    const handleSubmit = () => {
        if (selectedFile) {
            onSubmit({
                masavExportId: parseInt(id),
                file: selectedFile
            })
        }
    }

    if (loading && !currentExport) {
        return (
            <Box sx={styles.loadingContainer}>
                <CircularProgress />
            </Box>
        )
    }

    if (!currentExport) {
        return (
            <Box sx={styles.container}>
                <Alert severity="error">לא נמצא ייצוא מסב</Alert>
            </Box>
        )
    }

    return (
        <Box sx={styles.container}>
            <Box sx={styles.header}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate('/masav-exports')}
                >
                    חזרה לארכיון
                </Button>
            </Box>

            <Paper sx={styles.paper}>
                <Typography variant="h5" sx={styles.title}>
                    העלאת קובץ אישור ממסב
                </Typography>

                <Box sx={styles.exportInfo}>
                    <Typography variant="body1">
                        <strong>מספר ייצוא:</strong> {currentExport.id}
                    </Typography>
                    <Typography variant="body1">
                        <strong>תאריך ייצוא:</strong> {new Date(currentExport.exportDate).toLocaleDateString('he-IL')}
                    </Typography>
                    <Typography variant="body1">
                        <strong>מספר פניות:</strong> {currentExport.inquiriesCount}
                    </Typography>
                    <Typography variant="body1">
                        <strong>סכום כולל:</strong> ₪{currentExport.totalAmount.toLocaleString()}
                    </Typography>
                </Box>

                {uploadSuccess ? (
                    <Alert severity="success" icon={<CheckCircleIcon />} sx={{ mt: 3 }}>
                        <Typography variant="h6">הקובץ הועלה בהצלחה!</Typography>
                        <Typography>מעביר אותך בחזרה לארכיון...</Typography>
                    </Alert>
                ) : (
                    <>
                        <Box sx={styles.uploadSection}>
                            <input
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                style={{ display: 'none' }}
                                id="confirmation-file"
                                type="file"
                                onChange={handleFileChange}
                            />
                            <label htmlFor="confirmation-file">
                                <Button
                                    variant="outlined"
                                    component="span"
                                    startIcon={<FileUploadIcon />}
                                    fullWidth
                                    sx={{ height: '60px', fontSize: '1.1rem' }}
                                >
                                    בחר קובץ אישור
                                </Button>
                            </label>

                            {selectedFile && (
                                <Box sx={styles.fileInfo}>
                                    <CheckCircleIcon color="success" />
                                    <Typography variant="body1">
                                        {selectedFile.name}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                        ({(selectedFile.size / 1024).toFixed(2)} KB)
                                    </Typography>
                                </Box>
                            )}
                        </Box>

                        {error && (
                            <Alert severity="error" sx={{ mt: 2 }}>
                                אירעה שגיאה בהעלאת הקובץ. אנא נסה שנית.
                            </Alert>
                        )}

                        <Box sx={styles.actions}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={handleSubmit}
                                disabled={!selectedFile || isSubmitting}
                                startIcon={isSubmitting ? <CircularProgress size={20} /> : <FileUploadIcon />}
                            >
                                {isSubmitting ? 'מעלה...' : 'העלה קובץ אישור'}
                            </Button>
                            <Button
                                variant="outlined"
                                size="large"
                                onClick={() => navigate('/masav-exports')}
                                disabled={isSubmitting}
                            >
                                ביטול
                            </Button>
                        </Box>
                    </>
                )}
            </Paper>
        </Box>
    )
}

